import React, { useState, useEffect } from 'react'
import { adminHttp } from "~/Admin/services/http";
import Pagination from "react-js-pagination";
import { connect } from "react-redux";
import AdminUploadList from "./AdminUploadList";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import PopupActions from "~/Components/PopupActions/PopupActions";

const AdminUploadLog = ({ match, event = null, ...props }) => {

    const [response, setResponse] = useState({});
    const [selected, setSelected] = useState([]);

    const loadData = (page = 1) => {
        adminHttp
            .get('/events/' + event.id + '/hosts-uploads?page=' + page,)
            .then(res => {
                setResponse(res.data);
            });
    };

    useEffect(loadData, [event]);

    const handleArchive = () => {
        adminHttp
            .post('/events/' + event.id + '/hosts-uploads/archive', {
                'ids': selected
            })
            .then(res => {
                setResponse(res.data);
            });
    };

    const handleActioned = () => {
        adminHttp
            .post('/events/' + event.id + '/hosts-uploads/actioned', {
                'ids': selected
            })
            .then(res => {
                setResponse(res.data);
            });
    };

    return (
        <div>
            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">

                    <AdminUploadList
                        selected={selected}
                        selectionChanged={data => setSelected(data)}
                        uploads={response.data} />

                    {response.per_page < response.total && (
                        <Pagination
                            activePage={response.current_page}
                            itemsCountPerPage={response.per_page}
                            totalItemsCount={response.total}
                            pageRangeDisplayed={5}
                            itemClass="page-item"
                            linkClass="page-link"
                            onChange={loadData}
                        />
                    )}
                </div>
            </div>

            {selected.length > 0 && (
                <PopupActions>
                    <ConfirmedButton
                        confirmText={"Are you sure you want to archive " + selected.length + " items ?"}
                        onClick={handleArchive}
                        className="btn btn-secondary btn-xs mr-3">
                        Archive ({selected.length})
                    </ConfirmedButton>
                    <ConfirmedButton
                        confirmText={"Are you sure you want to mark as actioned " + selected.length + " items ?"}
                        onClick={handleActioned}
                        className="btn btn-primary btn-xs mr-3">
                        Mark as actioned ({selected.length})
                    </ConfirmedButton>
                </PopupActions>
            )}
        </div>

    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminUploadLog);
